import React from 'react'

type FlagProps = {
  className?: string
}

const ratio = {
  width: 24,
  height: 16,
}

export const FlagUS: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 7410 3900" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="7410" height="3900" fill="#b22234" />
    <g fill="#fff">
      <rect width="7410" height="300" y="300" />
      <rect width="7410" height="300" y="900" />
      <rect width="7410" height="300" y="1500" />
      <rect width="7410" height="300" y="2100" />
      <rect width="7410" height="300" y="2700" />
      <rect width="7410" height="300" y="3300" />
    </g>
    <rect width="2964" height="2100" fill="#3c3b6e" />
  </svg>
)

export const FlagES: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 3 2" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="3" height="2" fill="#c60b1e" />
    <rect y="0.5" width="3" height="1" fill="#ffc400" />
  </svg>
)

export const FlagFR: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 3 2" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="1" height="2" x="0" fill="#0055a4" />
    <rect width="1" height="2" x="1" fill="#fff" />
    <rect width="1" height="2" x="2" fill="#ef4135" />
  </svg>
)

export const FlagSE: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 16 10" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="16" height="10" fill="#006aa7" />
    <rect x="0" y="4" width="16" height="2" fill="#fecc00" />
    <rect x="5" y="0" width="2" height="10" fill="#fecc00" />
  </svg>
)

export const FlagDE: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 5 3" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="5" height="3" fill="#000" />
    <rect y="1" width="5" height="1" fill="#dd0000" />
    <rect y="2" width="5" height="1" fill="#ffce00" />
  </svg>
)

export const FlagID: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 3 2" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="3" height="1" y="0" fill="#ff0000" />
    <rect width="3" height="1" y="1" fill="#ffffff" />
  </svg>
)

export const FlagCN: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 30 20" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="30" height="20" fill="#de2910" />
    <polygon points="5,3 6,6 9,6 6.5,7.8 7.5,10.5 5,8.9 2.5,10.5 3.5,7.8 1,6 4,6" fill="#ffde00" />
  </svg>
)

export const FlagKR: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 3 2" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="3" height="2" fill="#fff" />
    <circle cx="1.5" cy="1" r="0.45" fill="#cd2e3a" />
    <path d="M1.5,1.45a0.45,0.45 0 0,1 0,-0.9a0.225,0.225 0 0,1 0,0.45a0.225,0.225 0 0,0 0,0.45" fill="#0047a0" />
  </svg>
)

export const FlagRU: React.FC<FlagProps> = ({ className }) => (
  <svg viewBox="0 0 3 2" width={ratio.width} height={ratio.height} className={className} aria-hidden="true">
    <rect width="3" height="0.666" y="0" fill="#fff" />
    <rect width="3" height="0.666" y="0.666" fill="#0039a6" />
    <rect width="3" height="0.668" y="1.332" fill="#d52b1e" />
  </svg>
)

export const getFlagByCode = (code: string): React.FC<FlagProps> => {
  switch (code) {
    case 'en':
      return FlagUS
    case 'es':
      return FlagES
    case 'fr':
      return FlagFR
    case 'sv':
      return FlagSE
    case 'de':
      return FlagDE
    case 'id':
      return FlagID
    case 'zh':
    case 'zh-CN':
      return FlagCN
    case 'ko':
      return FlagKR
    case 'ru':
      return FlagRU
    default:
      return FlagUS
  }
}


